module.exports = __webpack_public_path__ + "img/双脚测量脚型扫描仪.33db357d.png";